// extracted by mini-css-extract-plugin
module.exports = {"project":"Project_project__1FWtK height-100 width-100","annotationMode":"Project_annotationMode__3RIv3","handoffMode":"Project_handoffMode__2moxl bg-snow"};